import React from 'react';

const FloatingCards = ({ cards }) => {
  return (
    <div className="floating-cards-wrapper">
      <div className="floating-cards-container">
        {cards.map((card, index) => (
          <div key={index} className="floating-card-image-style">
            <div className="floating-card-image-bg" style={{ backgroundImage: `url(${card.image})` }}>
              {(card.title || card.subtitle) && (
                <div className="floating-card-overlay">
                  {card.title && <h3 className="floating-card-title-large">{card.title}</h3>}
                  {card.subtitle && <p className="floating-card-subtitle-large">{card.subtitle}</p>}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FloatingCards;
